import type Ajv8 from '@wix/dm-ajv'
import _ from 'lodash'

const customKeywords: any[] = [
    {
        keyword: 'isTopLevelDataNode',
        type: 'object',
        schemaType: ['boolean', 'null'],
        validate: () => true
    }
]

const addCustomKeywords = (ajv: Ajv8.Ajv2019) => {
    _.forEach(customKeywords, customKeyword => {
        ajv.addKeyword(customKeyword)
    })
}

export {addCustomKeywords}
